(function() {
    'use strict';

    angular.module("imApp").factory("activityManagerService", [function() {
        var service = {

        }

        return service;
    }]);
})();
